export const convertTimeStampToDate = (timestamp: string) => new Date(Number(timestamp))
    .toLocaleDateString("en-UK", {
      month: "short",
      day: "numeric",
      year: "numeric",
    })
    .replace(",", " ");
